var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-wrapper md:grid space-y-4 md:space-y-0 md:gap-y-8 md:gap-x-12 md:grid-cols-2"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }